export default __webpack_public_path__ + "static/media/format_study6.5876ef5e.svg";